import { forwardRef, Ref } from "react";

import { ToggleButton } from "@newsela/angelou";
import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";

import {
  toggleButtonCss,
  toggleLabelCss,
} from "./ContentSettingsToggle.styles";

interface ContentSettingsToggleProps {
  checked: boolean;
  onChange: () => void;
}

const ToggleWithTrackEvent = withTrackEvent(ToggleButton);

export const ContentSettingsToggle = forwardRef<
  HTMLButtonElement,
  ContentSettingsToggleProps
>(
  (
    { checked, onChange }: ContentSettingsToggleProps,
    ref: Ref<HTMLButtonElement>,
  ) => {
    return (
      <ToggleWithTrackEvent
        __cssFor={{
          label: toggleLabelCss,
          Button: {
            root: toggleButtonCss,
          },
        }}
        label="Manage flagged content"
        pressed={checked}
        onClick={onChange}
        buttonRef={
          ref as
            | ((instance: HTMLButtonElement | null) => void)
            | React.RefObject<HTMLButtonElement>
        }
        dataProps={{ "data-qa-selector": "toggle-content-settings" }}
        objectType={objectTypes.content}
        actionName={actionNames.interact}
        streamProperties={{
          description: "Toggle content settings on search page",
        }}
      />
    );
  },
);
